(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapStyleData = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "defaults": {
    "style": "classic",
    "curvedEnd": "none"
  },
  "styles": [
    {
      "id": "classic",
      "title": "Classic",
      "helperText": "Clean, traditional outline.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "rally-small-holes",
      "title": "Rally (Small Holes)",
      "helperText": "Small perforations near the lugs.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "rally-small-holes"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "rally-large-holes",
      "title": "Rally (Large Holes)",
      "helperText": "Large round holes. Racing look.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "rally-large-holes"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "rally-hybrid",
      "title": "Hybrid Rally",
      "helperText": "Large and small holes combined.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "rally-hybrid"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "middles-cut",
      "title": "Middle Cut",
      "helperText": "Center cut at the watch end. Extra measurements.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "middles-cut"
      },
      "disabled": false,
      "priceModifier": null,
      "measurementHook": "middlesCutDimensions"
    },
    {
      "id": "wings-cut",
      "title": "Wings Cut",
      "helperText": "Shaped wings at the watch end. Extra measurements.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "wings-cut"
      },
      "disabled": false,
      "priceModifier": null,
      "measurementHook": "wingsCutDimensions"
    }
  ],
  "curvedEnd": [
    {
      "id": "none",
      "title": "No",
      "helperText": "Straight strap end.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "none"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "yes",
      "title": "Yes",
      "helperText": "Curved finish at the strap end.",
      "thumbnail": {
        "kind": "diagram",
        "variant": "yes"
      },
      "disabled": false,
      "priceModifier": null
    }
  ],
  "curvedEndNote": "Curved End is forced to No for Wings Cut and Middle Cut."
});

  function getOptions(field) {
    if (field === 'style') return DATA.styles;
    if (field === 'curvedEnd') return DATA.curvedEnd;
    return [];
  }

  function getOption(field, optionId) {
    return getOptions(field).find((item) => item.id === optionId) || null;
  }

  return Object.freeze({ DATA, getOptions, getOption });
});
